import { Component, inject, OnInit } from '@angular/core';
import { ThemeService } from './theme.service';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ToastService } from '../../shared/services/toast.service';

interface Theme {
  theme_id: string;
  value: string;
  color: string;
  year: string;
}

interface Status {
  name: string;
}

@Component({
  selector: 'app-groups',
  templateUrl: './theme.component.html',
  styleUrl: './theme.component.css',
})
export class ThemeComponent implements OnInit {
  visible: boolean = false;
  themes: { [key: string]: any[] } = {}; // Define the type as an object with string keys and array values
  status!: Status[];
  selectedTheme!: Theme[];
  theme: Theme = {
    theme_id: '',
    value: '',
    color: '',
    year: ''
  };
  selectedYear: number;
  currentYear: any=new Date().getFullYear();
  years: string[] = [];
  filteredAndSortedThemes: { year: string, themes: Theme[] }[] = [];

  private themeService=inject(ThemeService);
  private messageService = inject(MessageService);
  private toastService = inject(ToastService);
  isThemeLoading: boolean=false;



  ngOnInit(): void {

    this.getList();

  }

getList(){
  this.isThemeLoading=true
  const themePayload = {};
    this.themeService.getThemes(themePayload).subscribe(
      (data: any) => {
          try {
            const parsedData = data;
            this.themes = parsedData.data || []; 
           this.filteredAndSortedThemes = Object.keys(parsedData.data)
          .filter(year => this.themes[year].some(theme => theme.status === "1")) // Adjust filter criteria as needed
          .map(year => ({ year, themes: this.themes[year] }))
          .sort((a, b) => parseInt(b.year) - parseInt(a.year)); // Sort by year descending
          this.isThemeLoading=false
          } catch (error) {
            this.isThemeLoading=false

            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error fetching users', error);
      }
    );

}

filterAndSortThemes(): void {
  // Convert the object to an array, filter by status or any other criteria, and sort by year
  const filteredAndSortedThemes = Object.keys(this.themes)
    .filter(year => this.themes[year].some(theme => theme.status === "1")) // Adjust filter criteria as needed
    .map(year => ({ year, themes: this.themes[year] }))
    .sort((a, b) => parseInt(b.year) - parseInt(a.year)); // Sort by year descending
}

  selectTheme(selectedTheme: Theme) {
    this.visible = true;
    this.theme = selectedTheme; 
  }

  addTheme(){
    this.visible = true; 
    this.theme = {
      theme_id: '',
      value: '',
      color: '#000',
      year:new Date().getFullYear().toString()
    };;
  }

  addData(form: NgForm){
    if (form.valid) {
      const formData={
        "value":form.value.value, 
        "color":form.value.color,
        "year":form.value.year
     }
     const themeDataPayload = formData;

     this.themeService.addTheme(themeDataPayload).subscribe(
      (data: any) => {
          try {
            const parsedData = data;
            if(parsedData.error){
              alert(parsedData.message)
              this.toastService.error(parsedData.message);
            } else {
              this.getList();
              this.toastService.success(parsedData.message);
              this.visible = false;
            }
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error update theme', error);
      }
    );
    }
  } 

  updateData(form: NgForm){
    if (form.valid) {
      const formData={
        "theme_id":this.theme.theme_id,
        "value":form.value.value, 
        "color":form.value.color,
        "year":form.value.year
     }
     const themeDataPayload = formData;

     this.themeService.updateTheme(themeDataPayload).subscribe(
      (data: any) => {
          try {
            const parsedData = data;
            if(parsedData.error){
              this.toastService.error(parsedData.message);
            } else {
              this.getList();
              this.toastService.success(parsedData.message);
              this.visible = false;
            }
          } catch (error) {
            console.error('Error parsing decoded data:', error);
          }
      },
      (error) => {
        console.error('Error update theme', error);
      }
    );
    }
  } 

  deleteData(selectedTheme: Theme){
    const formData={
      "theme_id":selectedTheme.theme_id 
    }
   this.themeService.deleteTheme(formData).subscribe(
    (data: any) => {
        try {
          const parsedData = data;
          if(parsedData.error){
            this.toastService.error(parsedData.message);
          } else {
            this.getList();
            this.toastService.success(parsedData.message);
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
    },
    (error) => {
      console.error('Error delete theme', error);
    }
  );
  }

  copyData(){
    const formData={
    }
   const themeDataPayload = {formData};

   this.themeService.copyTheme(themeDataPayload).subscribe(
    (data: any) => {
        try {
          const parsedData = data;
          if(parsedData.error){
            this.messageService.add({ severity: 'warn', summary: 'Warn', detail: parsedData.message });
          } else {
            this.getList();
            this.messageService.add({ severity: 'success', summary: 'Success', detail: parsedData.message });
          }
        } catch (error) {
          console.error('Error parsing decoded data:', error);
        }
    },
    (error) => {
      console.error('Error copy theme', error);
    }
  );
  }

  closeModal(): void{
    this.visible = false;
  }


  private encodeToBase64(str: any): string {
    return btoa(unescape(encodeURIComponent(str)));
  }

  private decodeBase64ToText(base64String: any): string {
    return atob(base64String);
  }

}
